export function pushAnalyticsEvent(
  eventName: string,
  params: Record<string, any> = {},
) {
  // @ts-ignore
  if (typeof window.gtag !== "function") return;
  // @ts-ignore
  if (typeof window.gtag === "function") {
    // @ts-ignore
    window.gtag("event", eventName, { ...params });
  }
}
